import { Injectable } from '@angular/core';
import { Program, Cedant, Contract } from '../shared.types';
import { Observable, BehaviorSubject, from } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContractSelectorStateService {

  constructor() { }

  // TODO: consider refactoring each item into a more generic section ... may be
  isContractActive: boolean;
  isProgramActive:  boolean;
  isCedantActive:   boolean = true;

  isExpanded: boolean = false;

  private readonly programsSubject = new BehaviorSubject<Program[]>(null);
  readonly programs$: Observable<Program[]> = this.programsSubject.asObservable();
  set currentPrograms(val: Program[]) {
    this.programsSubject.next(val);
  }
  get currentPrograms() {
    return this.programsSubject.getValue();
  }

  private readonly programSubject = new BehaviorSubject<Program>(null);
  readonly program$: Observable<Program> = this.programSubject.asObservable();
  set currentProgram(val: Program) {
    this.programSubject.next(val);
  }
  get currentProgram() {
    return this.programSubject.getValue();
  }

  setCurrentProgramBytId(id: number) {
    const o$ = !this.currentPrograms ? this.programs$ : from([this.currentPrograms]);
    o$.subscribe(programs => {
      const program = (programs || []).find( c => c.id === id);
      this.currentProgram = program;
    });
  }

  setProgramActive() {
    this.isContractActive = false;
    this.isProgramActive  = true;
    this.isCedantActive   = false;
  }

  private readonly cedantSubject = new BehaviorSubject<Cedant>(null);
  readonly cedant$: Observable<Cedant> = this.cedantSubject.asObservable();
  set currentCedant(val: Cedant) {
    this.cedantSubject.next(val);
  }
  get currentCedant() {
    return this.cedantSubject.getValue();
  }

  setCurrentCedanById(id: number) {
    const o$ = !this.currentCedants ? this.cedants$ : from([this.currentCedants]);
    o$.subscribe(cedants => {
      const cedant = (cedants || []).find( c => c.id === id);
      this.currentCedant = cedant;
    });
  }

  setCedantActive() {
    this.isContractActive = false;
    this.isProgramActive  = false;
    this.isCedantActive   = true;
  }

  private readonly cedantsSubject = new BehaviorSubject<Cedant[]>(null);
  readonly cedants$: Observable<Cedant[]> = this.cedantsSubject.asObservable();
  set currentCedants(val: Cedant[]) {
    this.cedantsSubject.next(val);
  }
  get currentsCedants() {
    return this.cedantsSubject.getValue();
  }

  private readonly contractSubject = new BehaviorSubject<Contract>(null);
  readonly contract$: Observable<Contract> = this.contractSubject.asObservable();
  set currentContract(val: Contract) {
    this.contractSubject.next(val);
  }
  get currentContract() {
    return this.contractSubject.getValue();
  }

  private readonly contractsSubject = new BehaviorSubject<Contract[]>(null);
  readonly contracts$: Observable<Contract[]> = this.contractsSubject.asObservable();
  set currentContracts(val: Contract[]) {
    this.contractsSubject.next(val);
  }
  get currentContracts() {
    return this.contractsSubject.getValue();
  }

  setCurrentContractById(id: number) {
    const o$ = !this.currentContracts ? this.contracts$ : from([this.currentContracts]);
    o$.subscribe(contracts => {
      const contract = (contracts || []).find( c => c.id === id);
      this.currentContract = contract;
    });
  }

  setContractActive() {
    this.isContractActive = true;
    this.isProgramActive  = false;
    this.isCedantActive   = false;
  }

}
